import { user } from '../user/user'
import { multiFactor } from 'firebase/auth'
import { derived } from 'svelte/store'

export const mfa = derived(user, ($user) => {
	if (!$user) return []
	const mf = multiFactor($user)
	return mf.enrolledFactors
})
